/* eslint import/prefer-default-export: 0 */
import API from '../baseService';

export const getQuotes = () =>
  API.get('/users/quotes').then(response => response);
